export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: '47573ba', dateTime: 1783648504944 };